/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathNot = createReactComponent("outline", "math-not", "IconMathNot", [["path", { "d": "M5 12h14v4", "key": "svg-0" }]]);

export { IconMathNot as default };
//# sourceMappingURL=IconMathNot.mjs.map
